import * as React from "react"

const SvgComponent = (props) => (
  <svg
    viewBox="0 0 1395 1395"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
    }}
    {...props}
  >
    <circle
      cx={697.079}
      cy={697.079}
      r={697.079}
      style={{
        fill: "#e98a15",
      }}
    />
    <path
      d="m238.643 416.092 485.773-280.461 485.774 280.461-485.774 280.462-485.773-280.462ZM724.416 1257.48 238.643 977.019V416.096l485.773 280.462v560.922Z"
      style={{
        fill: "#a5a5a5",
        fillOpacity: 0,
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
      fill="none"
    />
    <path
      d="M1210.19 416.092v560.923l-485.774 280.461V696.554l485.774-280.462Z"
      style={{
        fillOpacity: 0,
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
      fill="none"
    />
  </svg>
)

export default SvgComponent
